/**
 * Helper functions for teasers
 * @module helpers/teasers
 */
export function checkIfActiveNonPrivate(campaigns) {
  return campaigns.active && campaigns.active.type !== 'private';
}
